import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SuccessDialogData } from '../../core/utils/dialog.models';

@Component({
	selector: 'success-dialog',
	templateUrl: './success-dialog.component.html'
})
export class SuccessDialogComponent implements OnInit {
	public title: string;
	public text: string;
	public okBtnText: string;

	public constructor(
		public dialogRef: MatDialogRef<SuccessDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: SuccessDialogData
	) {}

	public ngOnInit(): void {
		this.title = this.data.title;
		this.text = this.data.text;
		this.okBtnText = this.data.okBtnText;
	}

	public onOkClick(): void {
		this.dialogRef.close({ confirm: true });
	}

	public onCancelClick(): void {
		this.dialogRef.close({ confirm: false });
	}
}
